// root route
export const ROUTE_ROOT = '/';
export const BASE_MARKETING_URL = 'https://www.litterati.org/';

// create challenge form route
export const ROUTE_NOT_FOUND = '/not-found';

// privacy policy URL
export const TERMS_AND_CONDITIONS_URL = `https://creativecommons.org/licenses/by-sa/4.0/`;

// terms and privacy URL
export const PRIVACY_POLICY_URL = `${BASE_MARKETING_URL}privacy-policy`;

export const ABOUT_URL = `${BASE_MARKETING_URL}about`;

export const STORIES_OF_IMPACT_URL = `${BASE_MARKETING_URL}stories`;

export const HOW_IT_WORKS_URL = `${BASE_MARKETING_URL}how-it-works`;

export const MAPS_URL = `https://map.litterati.org/globalmap/`;

export const BECOME_PARTNER_URL = `${BASE_MARKETING_URL}become-partner`;

export const INSTAGRAM_URL = `https://www.instagram.com/litterati/`;

export const TWITTER_URL = `https://twitter.com/litterati`;

export const FACEBOOK_URL = `https://www.facebook.com/thelitterati/`;

export const IOS_APP_URL =
    'https://itunes.apple.com/us/app/litterati-crowdsource-cleaning-the-planet/id982782776?ct=website%3Fmt%3D8&pt=117703122';

export const ANDROID_APP_URL =
    'https://play.google.com/store/apps/details?id=org.litterati.android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
